import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { RootLayout } from './layouts/RootLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { DashboardPage } from './pages/DashboardPage';
import { AppsPage } from './pages/AppsPage';
import { AppCreatePage } from './pages/AppCreatePage';
import { WorkflowsPage } from './pages/WorkflowsPage';
import { WorkflowCreatePage } from './pages/WorkflowCreatePage';
import { SchemasPage } from './pages/SchemasPage';
import { SchemaCreatePage } from './pages/SchemaCreatePage';
import { FormsPage } from './pages/FormsPage';
import { FormCreatePage } from './pages/FormCreatePage';
import { DataModelerPage } from './pages/DataModelerPage';
import { FormBuilderPage } from './pages/FormBuilderPage';
import { SettingsPage } from './pages/SettingsPage';
import { AdminPage } from './pages/admin/AdminPage';
import { LoginPage } from './pages/LoginPage';
import { MagicLinkPage } from './pages/MagicLinkPage';

const routes: RouteObject[] = [
  // Auth routes (public)
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/magic-link',
    element: <MagicLinkPage />,
  },
  // Protected routes
  {
    path: '/',
    element: <AuthLayout><RootLayout /></AuthLayout>,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'apps',
        element: <AppsPage />,
      },
      {
        path: 'apps/new',
        element: <AppCreatePage />,
      },
      {
        path: 'apps/:appId',
        lazy: () => import('./pages/AppDetailPage'),
      },
      {
        path: 'workflows',
        element: <WorkflowsPage />,
      },
      {
        path: 'workflows/new',
        element: <WorkflowCreatePage />,
      },
      {
        path: 'workflows/:workflowId',
        lazy: () => import('./pages/WorkflowDesignerPage'),
      },
      {
        path: 'data',
        element: <SchemasPage />,
      },
      {
        path: 'data/new',
        element: <SchemaCreatePage />,
      },
      {
        path: 'data/:schemaId',
        element: <DataModelerPage />,
      },
      {
        path: 'forms',
        element: <FormsPage />,
      },
      {
        path: 'forms/new',
        element: <FormCreatePage />,
      },
      {
        path: 'forms/:formId',
        element: <FormBuilderPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'admin',
        element: <AdminPage />,
      },
    ],
  },
];

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(routes);
